import { HSOverlay } from "preline";
import { SubscriptionCtx } from "../../contexts/SubscriptionCtx";
import { upgradeBoxService } from "../../services/upgradeBoxService";
import { VideoTutorialModal } from "../../utils/video-tutorial-modal";

export function SidebarUpgradeBox() {
    let upgradeBox: null | HTMLElement = null;
    let unsubscribeSubscription: (() => void) | null = null;
    const videoTutorialModal = VideoTutorialModal();
    let $videoTutorialBox = null as HTMLElement | null;
    let $dismissButton = null as HTMLElement | null;
    let $videoTutorialModal = null as HTMLElement | null;

    function init() {
        $videoTutorialBox = document.getElementById('tutorial-box');
        $dismissButton = document.getElementById('video-banner-dismiss-btn');
        $videoTutorialModal = document.getElementById('video-tutorial-modal');
        populate();
        unsubscribeSubscription = SubscriptionCtx.subscribe(() => {
            populate();
        });

        $dismissButton?.addEventListener('click', ()=>{
          $videoTutorialBox!.classList.add("hidden");
        });

        HSOverlay.on('open',$videoTutorialModal!, () => {
            const videoPlayer = document.getElementById("video-tutorial-player") as HTMLVideoElement;
            videoPlayer.play();
          })
    }

    function cleanUp(){
      if(unsubscribeSubscription){
        unsubscribeSubscription();
      }
    }

    async function populate() {
        const planDetails = await upgradeBoxService.planDetails();
        if (planDetails && planDetails.show_welcome_video_box) {
            $videoTutorialBox!.classList.remove("hidden");
            videoTutorialModal.populate(planDetails.welcome_video_url);
        }else{
            handleUpgradeBoxVisibility(planDetails);
        }
    }

    function handleUpgradeBoxVisibility(planDetails: any) {
        if (planDetails && planDetails.user_type === 'Free') {
            if (planDetails.is_trial_running) {
                const daysLeftSpans = document.querySelectorAll('.days-left');
                const remainingDays = planDetails.allow_trial_days - planDetails.account_active_days;
                daysLeftSpans.forEach((span) => {
                    span.innerHTML = remainingDays.toString();
                });
                if (remainingDays <= 2) {
                    upgradeBox = document.getElementById('upgrade-box-4');
                    upgradeBox?.classList.remove('hidden');
                }else{
                    upgradeBox = document.getElementById('upgrade-box-1');
                    upgradeBox?.classList.remove('hidden');
                }
            } else {
                upgradeBox = document.getElementById('upgrade-box-2');
                upgradeBox?.classList.remove('hidden');
            }
        } else {
            if(planDetails && planDetails.show_book_a_demo_box === false) {
                return;
            }
            upgradeBox = document.getElementById('upgrade-box-1');
            upgradeBox?.classList.add('hidden');
            upgradeBox = document.getElementById('upgrade-box-2');
            upgradeBox?.classList.add('hidden');
            upgradeBox = document.getElementById('upgrade-box-3');
            upgradeBox?.classList.remove('hidden');
        }
        handleUpgradePlan();
    }

    function handleUpgradePlan() {
        const upgradeBox3 = document.getElementById('upgrade-box-3') as HTMLElement;
        upgradeBox3?.addEventListener('click', (event) => {
            event.preventDefault();
            window.open(import.meta.env.VITE_DEMO_URL, '_blank');
        });
    }

    function render() {
        return /*html*/`
        <div class="p-6 mt-auto">
            <!-- Video Tutorial Box -->
            <div id="tutorial-box" class="group hidden rounded-lg border border-gray-200 bg-white overflow-hidden dark:bg-neutral-900 dark:border-neutral-700">
              <div class="relative" aria-haspopup="dialog" aria-expanded="false" aria-controls="video-tutorial-modal" data-hs-overlay="#video-tutorial-modal">
                <div class="rounded-t-lg overflow-hidden cursor-pointer">
                  <img src="/images/media-preview-video.png" alt="Video Thumb" class="w-full h-auto max-w-full">
                </div>
                <span class="absolute cursor-pointer shrink-0 size-10 top-1/2 left-1/2 translate-y-[-50%] translate-x-[-50%] bg-black bg-opacity-40 rounded-full border-[1.50px] border-white flex items-center justify-center z-10">
                  <span class="play-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                      <path d="M14.2875 27.038C13.7875 27.363 13.281 27.3815 12.768 27.0935C12.256 26.8065 12 26.363 12 25.763V10.238C12 9.63799 12.256 9.19399 12.768 8.90599C13.281 8.61899 13.7875 8.63799 14.2875 8.96299L26.5125 16.7255C26.9625 17.0255 27.1875 17.4505 27.1875 18.0005C27.1875 18.5505 26.9625 18.9755 26.5125 19.2755L14.2875 27.038Z" fill="white"/>
                    </svg>
                  </span>
                  <span class="push-icon hidden">
                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                      <rect x="10.5" y="9" width="6" height="18" rx="1" fill="white"/>
                      <rect x="19.5" y="9" width="6" height="18" rx="1" fill="white"/>
                    </svg>
                  </span>
                </span>
              </div>
              <div class="px-4 py-3">
                <div>
                  <h4 class="text-gray-900 text-sm md:text-base font-semibold dark:text-white">Watch to learn</h4>
                  <p class="text-gray-600 text-xs font-normal dark:text-neutral-500">Know more about new version of Feedspace</p>
                </div>
                <div class="flex items-center justify-between gap-2 flex-wrap mt-3">
                  <button class="cursor-pointer text-blue-600 text-xs font-medium hover:text-blue-800 group-hover:text-blue-800" aria-haspopup="dialog" aria-expanded="false" aria-controls="video-tutorial-modal" data-hs-overlay="#video-tutorial-modal">Watch Video</button>
                  <button id="video-banner-dismiss-btn" class="cursor-pointer text-gray-600 text-xs font-normal hover:text-gray-900 dark:text-neutral-400 dark:hover:text-neutral-300">Dismiss</button>
                </div>
              </div>
           </div>
           <!-- End Video Tutorial Box -->
            <!-- Upgrade Box 1 -->
            <a id="upgrade-box-1" class="upgrade-box cursor-pointer px-4 py-3 bg-gradient-to-l from-blue-50 to-white rounded-lg border border-blue-200 flex-col justify-start items-start gap-2 inline-flex dark:from-neutral-900 dark:to-neutral-950 dark:border-neutral-700 hidden"
            aria-haspopup="dialog" aria-expanded="false" aria-controls="hs-full-screen-modal"
             href="#my-account?tab=plans">
            <h4 class="flex gap-1 items-center text-gray-900 text-base font-semibold leading-normal dark:text-white">
            <span class="shrink-0">
              <svg class="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="lucide lucide-timer">
                  <line x1="10" x2="14" y1="2" y2="2" />
                  <line x1="12" x2="15" y1="14" y2="11" />
                  <circle cx="12" cy="14" r="8" />
              </svg>
          </span>  
            <span class="days-left"></span> Days Left
            </h4>
            <p class="text-gray-600 text-xs font-normal leading-tight dark:text-neutral-500">To upgrade your plan to unlock everything</p>
            <p><span
                class="flex gap-1 text-blue-600 text-sm font-medium leading-tight dark:text-neutral-400 hover:text-neutral-900 dark:hover:text-white">Upgrade Plan <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M4.66666 4.66797H11.3333V11.3346" stroke="currentColor" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M4.66666 11.3346L11.3333 4.66797" stroke="currentColor" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg></span></p>
            </a>
            <!-- End Upgrade Box 1 -->

            <!-- Upgrade Box 2 -->
            <a id="upgrade-box-2" class="upgrade-box cursor-pointer px-4 py-3 bg-gradient-to-l from-red-100 to-white rounded-lg border border-red-200 flex-col justify-start items-start gap-2 inline-flex dark:from-neutral-900 dark:to-neutral-950 dark:border-neutral-700 hidden"
            aria-haspopup="dialog" aria-expanded="false" aria-controls="hs-full-screen-modal"
            href="#my-account?tab=plans">
            <h4 class="flex gap-1 items-center text-red-800 text-base font-semibold leading-normal dark:text-white">
              <span class="shrink-0">
                <svg class="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-lock-keyhole"><circle cx="12" cy="16" r="1"/><rect x="3" y="10" width="18" height="12" rx="2"/><path d="M7 10V7a5 5 0 0 1 10 0v3"/></svg>
              </span>
              Free Plan
            </h4>
            <p class="text-red-800 text-xs font-normal leading-tight dark:text-neutral-500">Pick your plan to unlock your benefits</p>
            <p><span
                class="flex gap-1 text-blue-600 text-sm font-medium leading-tight dark:text-neutral-400 hover:text-neutral-900 dark:hover:text-white">Upgrade Plan <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M4.66666 4.66797H11.3333V11.3346" stroke="currentColor" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M4.66666 11.3346L11.3333 4.66797" stroke="currentColor" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg></span></p>
            </a>
            <!-- End Upgrade Box 2 -->

            <!-- Upgrade Box 3 -->
            <a id="upgrade-box-3" href="#my-account?tab=plans" class="cursor-pointer px-4 py-3 bg-gradient-to-l from-yellow-50 to-white rounded-lg border border-yellow-200 flex-col justify-start items-start gap-2 inline-flex dark:from-neutral-900 dark:to-neutral-950 dark:border-neutral-700 hidden">
                <h4 class="flex gap-1 items-center text-gray-900 text-base font-semibold leading-normal dark:text-white">
              <span class="shrink-0">
                <svg class="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-calendar-clock"><path d="M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5"/><path d="M16 2v4"/><path d="M8 2v4"/><path d="M3 10h5"/><path d="M17.5 17.5 16 16.3V14"/><circle cx="16" cy="16" r="6"/></svg>
                </span>Book Demo</h4>
            <p class="text-gray-600 text-xs font-normal leading-tight dark:text-neutral-500">To learn more about Feedspace</p>
            <p><span class="flex gap-1 text-blue-600 text-sm font-medium leading-tight dark:text-neutral-400 hover:text-neutral-900 dark:hover:text-white">Pick Time Slot
              <svg class="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-up-right"><path d="M7 7h10v10"/><path d="M7 17 17 7"/></svg>
              
          </span></p>
            </a>
            <!-- End Upgrade Box 3 -->

            <!-- Upgrade Box 4 -->
            <a id="upgrade-box-4" class="upgrade-box cursor-pointer px-4 py-3 bg-gradient-to-l from-red-100 to-white rounded-lg border border-red-200 flex-col justify-start items-start gap-2 inline-flex dark:from-neutral-900 dark:to-neutral-950 dark:border-neutral-700 hidden"
            aria-haspopup="dialog" aria-expanded="false" aria-controls="hs-full-screen-modal"
            href="#my-account?tab=plans">
            <h4 class="flex gap-1 items-center text-red-800 text-base font-semibold leading-normal dark:text-white">
              <span class="shrink-0">
                <svg class="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="lucide lucide-triangle-alert">
                  <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                  <path d="M12 9v4" />
                  <path d="M12 17h.01" />
                </svg>
              </span>
              <span class="days-left"></span> Days Left
            </h4>
            <p class="text-red-800 text-xs font-normal leading-tight dark:text-neutral-500">To upgrade your plan to unlock everything</p>
            <p><span
                class="flex gap-1 text-blue-600 text-sm font-medium leading-tight dark:text-neutral-400 hover:text-neutral-900 dark:hover:text-white">Upgrade Plan <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M4.66666 4.66797H11.3333V11.3346" stroke="currentColor" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M4.66666 11.3346L11.3333 4.66797" stroke="currentColor" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg></span></p>
            </a>
            <!-- End Upgrade Box 4 -->
        </div>
        `;
    }

    return {
        render,
        init,
        cleanUp
    }
}